import { OpcoUserStatus } from '@/bundle/_Opco/_OpcoUsersPage/ui/OpcoUserStatus/OpcoUserStatus';
import { UserRole } from '../../../shared/UserRole/UserRole';
import { formatDateTimeUTC } from '@/helpers/dateHelpers/dateHelpers';
import MasterAdminIcon from '../images/MasterAdminIcon.svg?react';
import OrgAdminIcon from '../images/OrgAdminIcon.svg?react';
import { ORG_ADMIN_ROLE, ORGANIZATION_USER_ROLE_LABEL_MAP } from '@/const/user';
import { TableConfigItemsListType } from '@/components/Table/types/types';
import { OrganizationUserType } from '@/bundle/_Opco/types/types';
import { UtcTooltip } from '@/components/UtcTooltip/UtcTooltip';

export const ORGANIZATION_USER_ROLE_ICON_MAP = {
  [ORG_ADMIN_ROLE.MASTER_ADMIN]: <MasterAdminIcon />,
  [ORG_ADMIN_ROLE.ORG_ADMIN]: <OrgAdminIcon />,
};

export const ORGANIZATIONS_USERS_TABLE_CONFIG: TableConfigItemsListType<OrganizationUserType> = [
  {
    key: 1,
    name: 'user__email,-user__date_created',
    header: 'EMAIL ADDRESS',
    width: '20%',
    hasSort: true,
    getValue({ email }) {
      return { value: email, title: email };
    },
  },
  {
    key: 2,
    name: 'user__first_name,-user__date_created',
    header: 'FIRST NAME',
    width: '20%',
    hasSort: true,
    getValue({ first_name }) {
      return { value: first_name || '-', title: first_name };
    },
  },
  {
    key: 3,
    name: 'user__last_name,-user__date_created',
    header: 'LAST NAME',
    width: '20%',
    hasSort: true,
    getValue({ last_name }) {
      return { value: last_name || '-', title: last_name };
    },
  },
  {
    key: 4,
    name: 'role,-user__date_created',
    header: 'ROLE',
    width: '15%',
    hasSort: true,
    getValue({ role }) {
      const formattedRole = ORGANIZATION_USER_ROLE_LABEL_MAP[role] || role;
      const icon = ORGANIZATION_USER_ROLE_ICON_MAP[role];

      return {
        value: <UserRole role={formattedRole} icon={icon} />,
      };
    },
  },
  {
    key: 5,
    name: 'user_status,-user__date_created',
    header: 'STATUS',
    width: '10%',
    hasSort: true,
    getValue({ status }) {
      return {
        value: <OpcoUserStatus status={status} />,
      };
    },
  },
  {
    key: 6,
    name: 'user__last_login,-user__date_created',
    header: 'LAST LOGIN',
    width: '15%',
    hasSort: true,
    tooltip: <UtcTooltip message='Last login is recorded in UTC' />,
    getValue({ last_login }) {
      const formattedDate = formatDateTimeUTC(last_login);

      return { value: formattedDate, title: formattedDate };
    },
  },
];
